import { render } from "./OhiloFooter.vue?vue&type=template&id=0ade5b92"
import script from "./OhiloFooter.vue?vue&type=script&lang=js"
export * from "./OhiloFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__